module.exports = __webpack_public_path__ + "static/media/sndvol32_304.300c4eab.ico";